import { assetProxyModule } from "@mem-labs/common-editor";
import { getBackendAssetProxyUrl } from "@/manager/backend-api-client/initializeBackendApiManager";
import { AssetAccessTokenState } from "@/store/auth/AssetAccessTokenState";

type BuildProxiedAssetUrlArgs = {
  originalUrl: string | null | undefined;
  assetAccessTokenState: AssetAccessTokenState | null | undefined;
};

export const buildProxiedAssetUrl = ({
  originalUrl,
  assetAccessTokenState,
}: BuildProxiedAssetUrlArgs): string | null => {
  if (!originalUrl) {
    return null;
  }

  if (!assetAccessTokenState?.token) {
    return null;
  }

  const expiresAtIso = assetAccessTokenState.expiresAt?.toUTC().toISO() ?? null;

  return (
    assetProxyModule.buildProxyUrl({
      originalUrl,
      config: {
        baseUrl: getBackendAssetProxyUrl(),
        auth: {
          assetAccessToken: assetAccessTokenState.token,
          expiresAt: expiresAtIso,
        },
      },
    }) ?? null
  );
};
